import Text from 'components/shared/Text'
import { OPERATING_FEE, FAMILY_PACKAGE_OPERATING_FEE } from 'constants/prices'
import { FormattedMessage } from 'react-intl'
import { SelfcareInfoBox, SelfcareInfoList } from './styles'
import { formatPrice } from 'helpers/helpers'
import Link from 'components/shared/Link'
import {
    MARCH_PROMOTION_REGULATIONS_LINK,
    SUNTAGO_ONLINE_TICKET_SALES_REGULATIONS_LINK_CHANGES_PAGE,
} from 'constants/links'
import { useAppSelector } from 'store/hooks'

const SelfcareInfo = () => {
    const { ticketsBundles, isMarchPromoMode } = useAppSelector(
        (state) => state.selfcare
    )

    const isFamilyPackageInOrder = ticketsBundles?.length

    return (
        <SelfcareInfoBox gap={8} pt={24} pb={24} pl={16} pr={16} mt={[16, 74]}>
            <Text variant="heading5" color="secondary_500">
                <FormattedMessage
                    id="selfcare.summary.info_title"
                    defaultMessage="Warto wiedzieć"
                />
            </Text>
            <SelfcareInfoList gap={8}>
                {isMarchPromoMode ? (
                    <Text variant="bodyExtraSmall" color="grayscale_900">
                        <FormattedMessage
                            id="selfcare.summary.info_march_promo"
                            defaultMessage="_"
                        />
                    </Text>
                ) : (
                    <>
                        <Text variant="bodyExtraSmall" color="grayscale_900">
                            {isFamilyPackageInOrder ? (
                                <FormattedMessage
                                    id="package.family.info_change_fees"
                                    defaultMessage="Anulowanie lub zmiana w każdej usłudze wiąże się z opłatą operacyjną ({family_price} w przypadku Pakietu Family oraz {price} w przypadku pozostałych zmian). Opłata nie dotyczy dodawania kolejnych usług. "
                                    values={{
                                        family_price: formatPrice(
                                            FAMILY_PACKAGE_OPERATING_FEE,
                                            true
                                        ),
                                        price: formatPrice(OPERATING_FEE, true),
                                    }}
                                />
                            ) : (
                                <FormattedMessage
                                    id="selfcare.summary.info_change_fees"
                                    defaultMessage="Anulowanie lub zmiana w każdej usłudze wiąże się z opłatą operacyjną ({price}). Opłata nie dotyczy dodawania kolejnych usług."
                                    values={{
                                        price: formatPrice(OPERATING_FEE, true),
                                    }}
                                />
                            )}
                        </Text>
                        <Text variant="bodyExtraSmall" color="grayscale_900">
                            <FormattedMessage
                                id="selfcare.summary.info_voucher"
                                defaultMessage="Ewentualną różnicę w cenie zwrócimy na voucher prezentowy."
                            />
                        </Text>
                    </>
                )}
            </SelfcareInfoList>
            <Link
                variant="secondary"
                target="_blank"
                icon={null}
                path={
                    isMarchPromoMode
                        ? MARCH_PROMOTION_REGULATIONS_LINK
                        : SUNTAGO_ONLINE_TICKET_SALES_REGULATIONS_LINK_CHANGES_PAGE
                }
                data-testid="selfcare-aside-info-redirect-regulations"
            >
                <Text variant="bodyExtraSmall" ml={4} as="span">
                    {isMarchPromoMode ? (
                        <FormattedMessage
                            id="selfcare.summary.regulations_march_promo"
                            defaultMessage="Regulamin"
                        />
                    ) : (
                        <FormattedMessage
                            id="global.regulations"
                            defaultMessage="Regulamin"
                        />
                    )}
                </Text>
            </Link>
        </SelfcareInfoBox>
    )
}

export default SelfcareInfo
